<template>
	<div>
		<h2>Movimientos</h2>
		<br>

		<input type='text' placeholder='BUSCAR' v-model='abuscar'  >
		<br><br>	

		<router-link id='agrega':to="{name: 'agre-movi'}">Agregar</router-link>
		<br>
		<br>
		
		<table align="center" id='todos' v-if="movimientosTodos !=null" class="table is-striped is-hoverable">
			<tbody>
				<tr>
					<th>Tipo</th>
					<th>Contrato</th>
					<th>Inquilino</th>
					<th>Propiedad</th>
					<th>Giro</th>
					<th>Familia</th>
					<th>Concepto</th>
					<th>Importe</th>
					<th>Fecha</th>
					<th>Forma</th>
					<th>Ref.</th>
					<th>Ref. Dep.</th>
				</tr>

				
				<tr v-for="movi in buscando" >	
					<td>{{movi.tipo}}</td>
					<td>{{movi.contrato}}</td>
					<td>{{movi.inquilinoNombre}}</td>
					<td>{{movi.propiedadNombre}}</td>
					<td>{{movi.giro}}</td>
					<td>{{movi.familia}}</td>
					<td>{{movi.concepto}}</td>
					<td><p align="right">$ {{formateaNumero(movi.importe)}}</p></td>
					<td>{{formateaFecha(movi.fecha)}}</td>
					<td>{{movi.formaDePago}}</td>
					<td>{{movi.referencia}}</td>
					<td>{{movi.refDeposito}}</td>
				</tr>
				
			</tbody>
		</table>

		<span v-else><button class="button is-primary is-loading">Loading</button></span>
	</div>
</template>


<script>
import axios from 'axios';

export default {
  name: 'Movimientos',
  mounted(){
  	this.getMovimientos();
  },
  props: ['vector'],  
  data () {
    return {
      movimientosTodos: null,
      abuscar: ''
    }
  },
  methods:{
  	getMovimientos(){
 		// checa si tiene autorizacion
  		if(!this.vector.includes('MASTERGGUV')){
	  		if(!this.vector.includes('Movimientos')){
	  			alert('Seccion no autorizada');
	  			return;
	  		}
	  	} 		
  		
  		axios.get('https://www.directodo.com/Rentus/accesosdb/leeMovimientos.php')
  		     .then((respuesta) => {
  		     	this.movimientosTodos = respuesta.data;
  			 });
  	},

	formateaFecha: function (fecha) {
		var d = new Date(fecha); 
		d.setMinutes(d.getMinutes() + d.getTimezoneOffset() ); 
		d.setHours(0);

		if (Date.parse(d)){
			//var opciones = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
			var opciones = { year: 'numeric', month: 'short', day: 'numeric' };
			d = new Intl.DateTimeFormat('es-mx', opciones).format(d);
			return d} 
		else{return "sin fecha";}
	},

    formateaNumero(valor1) {
        return (Number(valor1)).toLocaleString('en-US', {minimumFractionDigits: 2, useGrouping:true});
    }

  },

   computed:{
	 	buscando: function (){
	  		return this.movimientosTodos.filter((item) =>  
	  			   item.tipo.toUpperCase().includes(this.abuscar.toUpperCase()) 
	  			|| item.contrato.toUpperCase().includes(this.abuscar.toUpperCase()) 
	  			|| item.inquilinoNombre.toUpperCase().includes(this.abuscar.toUpperCase()) 
	  			|| item.propiedadNombre.toUpperCase().includes(this.abuscar.toUpperCase()) 
	  			|| item.giro.toUpperCase().includes(this.abuscar.toUpperCase()) 
	  			|| item.familia.toUpperCase().includes(this.abuscar.toUpperCase()) 
	  			|| item.concepto.toUpperCase().includes(this.abuscar.toUpperCase()) 
 
	  		);
	  	}
	}



}
</script>

<style lang="scss">

</style>




// WEBPACK FOOTER //
// src/Movimientos.vue